import { render } from "./Tooltip.vue?vue&type=template&id=64ea90e8&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"

import "./Tooltip.vue?vue&type=style&index=0&id=64ea90e8&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ea90e8"]])

export default __exports__